export interface ExControlConfig {
  type: 'default' | 'slider' | 'combined-slider';
}
